module.exports = __webpack_public_path__ + "static/media/bottom_shape_4_mob.3a78c4b6.svg";